import { createApi } from '@/api/modules/utils'

const baseUrl = '/self_media_platform/detail'
const api = createApi(baseUrl)

// 自建站平台详情
export const selfMediaPlatformDetailApi = {
    list: api('list', 'get'),
    search: api('search', 'get'),
    delete: api('delete', 'get'),
    config: api('config', 'get'),
    insert: api('insert', 'post'),
    getToken: api('get_token', 'post'),
}